import { makeStyles } from '@material-ui/core'
import { colors } from '../../../../theme/colors'

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: 32,
    marginBottom: 16,
  },
  sectionHeading: {
    color: colors.TEXT,
    fontWeight: 600,
    textTransform: 'uppercase',
    marginBottom: 20,
  },
  showMore: {
    display: 'block',
    margin: '0 auto',
  },
  modalButtons: {
    width: 152,
    marginRight: theme.spacing(2),
    '&:last-child': {
      marginRight: 0,
    },
  },
}))
